<template>
  <transition name="slide-right">
    <cube-popup
      v-show="isVisible"
      type="my-popup"
      :center="false"
      position="right"
      class="filter-wrap"
    >
      <div class="areas-searchs-box">
        <cube-input
          ref="searchInput"
          :clearable="true"
          @input="handleInput"
          @change="searchHandle"
        >
          <template slot="prepend">
            <i class="iconfont iconicon-test29" />
          </template>
          <template slot="append">
            <span
              class="text-btn search"
              @click="handleSearch"
            >
            <!-- {{ $t('message["1156"]') }} -->
            </span>
          </template>
        </cube-input>
      </div>
      <div class="path">
        <!-- <i class="iconfont iconicon-test21" /> -->
        <span
          class="tag"
          @click="clickTagHandle(0)"
        >
          <!-- {{ $t('message["904"]') }} -->
        </span>
        <span
          v-for="(item, index) in value1"
          :key="item[fieldKey]"
          class="tag"
          @click="clickTagHandle(index + 1)"
        >
          {{ item[fieldName] }}
        </span>
        <span
          v-if="value2"
          class="tag last"
        >
          {{ value2[fieldName] }}
        </span>
      </div>
      <div class="main">
        <div
          v-if="loading"
          class="fetching"
        >
          <cube-loading :size="40" />
        </div>
        <div
          v-else-if="empty"
          class="empty margin-left-16"
        >
          <img
            src="@/assets/images/logo-gray.png"
            class="logo-icon"
          >
          <p class="empty-text">
            {{ emptyTxt }}
          </p>
          <div
            v-if="showReportBox"
            class="report-box"
          >
            <p>
              {{ reportShowTxt }}
              ？</p>
            <div class="btns">
              <a
                @click="showReportBox = false"
              >
                {{ reportHideTxt }}
              </a>
              <a
                class="report-btn"
                @click="handleReport"
              >
                {{ reportBtnTxt }}
              </a>
            </div>
          </div>
          <div
            v-if="reportSuccess"
            class="report-result"
          >
            <p class="report-success">
              {{ reportSucTxt }}
            </p>
          </div>
        </div>
        <template v-else>
          <cube-scroll
            v-if="!isSearch"
            ref="linkScroll"
            :data="lists"
          >
            <ul
              ref="ul"
              class="list"
            >
              <li
                v-for="item in lists"
                :key="item[fieldKey]"
                class="item border-bottom-1px"
                :class="{selected: value2 ? item[fieldKey] === value2[fieldKey] : false}"
                @click="clickItemHandle(item)"
              >
                <span class="left">
                  {{ item[fieldName ] }}
                  <span
                    v-if="item.country_code !== 'CHN' && item.en_name"
                    class="en-name"
                  >（{{ item.en_name }}）</span>
                </span>

                <i
                  v-if="item.haschildren!==0"
                  class="more iconfont iconicon-test18"
                />
                <i
                  v-else
                  class="activeicon iconfont iconicon-test16"
                />
                <!-- <i
                v-if="hasChild(item)"
                class="more iconfont iconicon-test18"
              />
              <i
                v-if="!hasChild(item) "
                class="activeicon iconfont iconicon-test16"
              /> -->
              </li>
            </ul>
          </cube-scroll>
          <cube-scroll
            v-else
            ref="linkScroll"
            :data="lists"
          >
            <ul class="list">
              <li
                v-for="(item, index) in searchLists"
                :key="searchs[index].key"
                class="item border-bottom-1px"
                @click="clickSearchItemHandle(item)"
              >
                <span v-html="searchs[index].html" />
              </li>
            </ul>
          </cube-scroll>
        </template>
      </div>
      <div class="form-btn-box">
        <cube-button
          :light="true"
          @click="cancelHandle"
        >
          {{ cancelTxt }}
        </cube-button>
        <cube-button
          :primary="true"
          @click="confirmHandle"
        >
          {{ okTxt }}
        </cube-button>
      </div>
    </cube-popup>
  </transition>
</template>

<script>
import i18n from '@/lib/language'
export default {
  name: 'Linkage',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: Array,
      default: () => []
    },
    fieldKey: {
      type: String,
      default: 'code'
    },
    fieldName: {
      type: String,
      default: 'name'
    },
    hasChild: {
      type: Function,
      default: () => true
    },
    getData: {
      type: Function,
      required: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    searchData: {
      type: Function,
      default: () => []
    },
    reportSearch: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    const { defaultValue } = this
    return {
      isVisible: false,
      keyword: '',
      isSearch: false,
      value1: defaultValue.concat([]),
      value2: null,
      lists: [],
      searchLists: [],
      loading: false,
      showReportBox: false,
      reportSuccess: false
    }
  },
  computed: {
    empty () {
      if (this.isSearch) {
        return !this.searchLists.length
      } else {
        return !this.lists.length
      }
    },
    searchs () {
      const { fieldKey, fieldName, keyword } = this
      const { searchLists = [] } = this
      /* return searchLists.map(arr => {
        return {
          key: arr.map(item => item[fieldKey]).join('/'),
          html: arr.map(item => {
            return item[fieldName].replace(keyword, `<span style="color: red !important;">${keyword}</span>`)
          }).join(' / ')
        }
      }) */
      return searchLists.map(arr => {
        let htmlArr = arr.map((item, i) => {
          let { name = '', en_name: enName = '' } = item[fieldName]
          let text = ''
          let isChinese = /.*[\u4e00-\u9fa5]+.*$/.test(keyword)
          if (isChinese) { // 搜索输入的是中文
            name = name.replace(keyword, `<span style="color: red">${keyword}</span>`)
            if (i === arr.length - 1 && enName) {
              text = `${name}(${enName})`
            } else {
              text = `${name}`
            }
          } else { // 非中文
            if (i === arr.length - 1 && enName) {
              enName = enName.replace(keyword, `<span style="color: red">${keyword}</span>`)
              text = `${name}(${enName})`
            } else {
              text = `${name}`
            }
          }
          return text
        })
        let html = ''
        if (htmlArr.length > 1) {
          html = htmlArr.join(' / ')
        } else {
          html = htmlArr.join('')
        }

        let newArr = {
          key: arr.map(item => item[fieldKey]).join('/'),
          html
        }
        return newArr
      })
    },
    okTxt () {
      return i18n.t('message["915"]')
    },
    cancelTxt () {
      return i18n.t('message["896"]')
    },
    reportSucTxt () {
      return i18n.t('message["1473"]')
    },
    reportBtnTxt () {
      return i18n.t('message["1161"]')
    },
    reportHideTxt () {
      return i18n.t('message["71"]')
    },
    reportShowTxt () {
      return i18n.t('message["1098"]')
    },
    emptyTxt () {
      return i18n.t('message["1548"]')
    }
  },
  watch: {
    isVisible: {
      handler (val) {
        if (val) {
          this.initRoutes(this.defaultValue, true)
        }
        if (val && this.showSearch) {
          setTimeout(() => {
            this.$refs.searchInput.focus()
          }, 10)
        }
      }
    }
  },
  async created () {
    /* const unwatch = this.$watch('isVisible', function () {
      this.initRoutes(this.defaultValue, true)
      unwatch()
    }) */
  },
  methods: {
    show () {
      this.isVisible = true
    },
    cancelHandle () {
      this.isVisible = false
      this.$emit('update', false)
      // this.$emit('update:visible', false)
      this.value1 = []
      this.value2 = null
    },
    // cancelSearchHandle () {
    //   this.keyword = ''
    //   this.isSearch = false
    //   this.value1 = []
    //   this.value2 = null
    //   this.searchLists = []
    //   this.initRoutes(this.defaultValue, true)
    // },
    async searchHandle (e) {
      this.keyword = e.target.value
      this.handleSearch()
    },
    handleInput (value) {
      this.keyword = value
      if (!value) {
        this.keyword = ''
        this.isSearch = false
        this.value1 = []
        this.value2 = null
        this.clickTagHandle(0)
      }
    },
    async handleSearch () {
      this.isSearch = true
      this.loading = true
      if (this.keyword) {
        this.searchLists = await this.searchData({ keyword: this.keyword })
        if (!this.searchLists.length) {
          if (this.reportSearch.toString() === 'function _default() {}') {
            this.showReportBox = false
            this.reportSuccess = false
          } else {
            this.showReportBox = true
            this.reportSuccess = false
          }
        }
      }
      this.loading = false
    },
    async clickTagHandle (level) {
      this.isSearch = false
      this.loading = true
      const params = {
        level
      }
      if (level) {
        this.value2 = this.value1.slice(level - 1, level)[0]
        this.value1 = this.value1.slice(0, level - 1)
        this.$emit('change', this.value1.concat(this.value2), true)
        params.data = this.value2
      } else {
        this.$emit('change', [], true)
        this.value1 = []
        this.value2 = null
        params.data = null
      }
      this.lists = await this.getData(params)
      if (this.lists.length && this.value2) {
        this.value1 = this.value1.concat(this.value2)
        this.value2 = null
      }
      this.loading = false
    },
    async clickItemHandle (item) {
      this.isSearch = false
      this.value2 = item
      // this.$emit('change', this.value1.concat(this.value2))
      if (!this.hasChild(item)) {
        if (this.hideOnComplete) {
          this.isVisible = false
        }
        this.$emit('change', this.value1.concat(this.value2), false)
        // this.$emit('complete', this.value1.concat(this.value2), false)
        return
      }
      this.loading = true
      const level = this.value1.length + 1
      const lists = await this.getData({
        level,
        data: item
      })
      if (lists && lists.length) {
        this.$emit('change', this.value1.concat(this.value2), true)
        this.lists = lists
        this.value2 = null
        this.value1 = this.value1.concat(item)
      } else {
        this.value2 = item
        if (this.hideOnComplete) {
          this.isVisible = false
        }
        this.$emit('change', this.value1.concat(this.value2), false)
      }
      this.loading = false
    },
    async clickSearchItemHandle (item) {
      let newItem = item.map(one => {
        return {
          code: one.code,
          name: one.name.name
        }
      })
      this.isSearch = false
      await this.initRoutes(newItem, false)
    },
    async initRoutes (routes, forCreated) {
      this.loading = true
      let defaultIndex = 0
      const { fieldKey } = this
      const { length } = routes
      if (!length) {
        this.lists = await this.getData({
          data: null,
          level: 0
        })
        this.loading = false
        return
      }
      this.value1 = routes
      this.value2 = null
      // 请求最后一级的数据
      const data = this.getLast(this.value1)
      const lists = await this.getData({
        data,
        level: this.value1.length
      })
      if (lists && lists.length) {
        this.lists = lists
        defaultIndex = this.lists.findIndex(item => {
          return item[fieldKey] === data[fieldKey]
        })
        if (!forCreated) {
          this.$emit('change', routes, true)
        }
      } else {
        if (length > 1) {
          // 请求倒数第二级数据
          const value1 = this.value1 = routes.slice(0, -1)
          const value2 = this.value2 = routes.slice(-1)[0]
          const data = this.getLast(value1)
          this.lists = await this.getData({
            data,
            level: this.value1.length
          })
          defaultIndex = this.lists.findIndex(item => {
            return item[fieldKey] === value2[fieldKey]
          })
        }
        if (!forCreated) {
          if (this.hideOnComplete) {
            this.isVisible = false
          }
          this.$emit('change', routes, false)
        }
      }
      this.loading = false
      if (defaultIndex > 3) {
        this.$nextTick(function () {
          const { ul } = this.$refs
          if (ul) {
            ul.scrollTop = (defaultIndex - 3) * 32
          }
        })
      }
    },
    async confirmHandle () {
      const { value1, value2 } = this
      const routes = value2 ? value1.concat(value2) : value1
      this.$emit('confirm', routes)

      this.isVisible = false
      this.$emit('update', false)
      // this.$emit('update:visible', false)
    },
    getLast (arr = []) {
      const newArr = arr.slice(-1)
      if (newArr.length) {
        return newArr[0]
      }
      return null
    },
    async handleReport () {
      // todo
      let res = await this.reportSearch(this.keyword)

      if (res) {
        this.showReportBox = false
        this.reportSuccess = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-wrap::v-deep {
  line-height: normal;
  .margin-left-16 {
    margin-left: 16px;
  }
  .cube-popup-content {
    // height: 100%;
    background: #fff;
    .path {
      // height: 46px;
      display: flex;
      line-height: 46px;
      border-top: 1px solid #dbdbdb;
      border-bottom: 1px solid #dbdbdb;
      padding: 0 12px;
      color: $primary-color;
      .tag {
        margin-right: 16px;
      }
    }
    .main {
      height: 100%;
      transform: rotate(0deg); // fix 子元素超出边框圆角部分不隐藏的问题
      position: relative;
      top: 0;
      bottom: 0;
      overflow: hidden;
    }
    .list {
      // height: 300px;
      // overflow-y: auto;
      // overflow-x: hidden;
      padding-bottom: 180px;
      li {
        // height: 47px;
        line-height: 24px;
        display: flex;
        justify-content: space-between;
        padding: 12px 16px;
        .more {
          vertical-align: middle;
          color: #ccc;
        }
        .activeicon {
          display: none;
        }
      }
      .selected {
        .left,
        .activeicon {
          color: $primary-color;
        }
        .activeicon {
          display: inline-block;
        }
      }
    }
    .areas-searchs-box {
      box-sizing: content-box;
      background: #f5f5f5;
      .cube-input_active:after {
        border: none !important;
      }
      .cube-input {
        padding: 8px;
        background-color: #f1f1f1;
        .cube-input-prepend {
          position: absolute;
          left: 13px;
          color: #999;
        }
        .cube-input-field {
          margin-right: 8px;
          padding: 7px 10px 7px 30px;
          background-color: #fff;
          border-radius: 4px;
        }
        .cube-input-append {
          color: $primary-color;
        }
      }
    }
    .empty {
      margin-top: 16px;
      text-align: center;
      .logo-icon {
        display: inline-block;
        width: 40px;
        color: #D6D6D6;
        font-size: 40px;
      }
      .empty-text {
        margin-top: 10px;
        color: #B3B3B3;
        font-size: 16px;
        line-height: 24px;
      }
      .report-box {
        width: 240px;
        margin: 48px auto 0;
        p {
          font-size: 14px;
          line-height: 24px;
          color: #808080;
        }
        .btns {
          margin: 22px 0;
          a {
            padding: 4px 14px;
            font-size: 14px;
          }
        }
        .report-btn {
          margin-left: 16px;
        }
      }
      .report-result {
        width: 240px;
        margin: 48px auto 0;
      }
      .report-success {
        color: #42C27E;
        line-height: 24px;
        font-size: 14px;
      }
    }
  }
}
.cube-btn {
  width: 48%;
}
</style>
